import { createContext, useContext } from 'react';

export type UserRoleContextType = {
    isAdmin: boolean;
    isDatasourceAdmin: boolean;
}

export const UserRoleContext = createContext<UserRoleContextType>({ isAdmin: false, isDatasourceAdmin: false });
UserRoleContext.displayName = 'UserRole';

export const useUserRole = () => {
    return useContext(UserRoleContext);
};
